import { useQuery } from "@tanstack/react-query";

import { getBettingSelectionMappings } from "@/api/bettingSelections";
import { BettingSelectionsQueryKeys } from "./bettingSelectionsQueryKeys";

export const useBettingSelectionMappings = (selectionId: number | null) => {
  return useQuery({
    queryKey: [BettingSelectionsQueryKeys.BettingSelectionMappings, selectionId],
    queryFn: ({ signal }) => getBettingSelectionMappings(selectionId!, { signal, params: {} }),
    enabled: selectionId !== null,
  });
};
